/// <summary>
/// SearchColumnData
/// ※ SCV\LibVue\scv-lib-vue\src\components\List\ListCtrlColumnData.tsと合わせてください。
///    いつかファイルを一つにまとめたい。。。
/// </summary>
export class SearchColumnData {
    // カラムID
    columnID = 0;

    // テキスト
    text = "";

    // データタイプ(ref : CtlSvr_Cloud\ClientApp\src\models\SearchDetailConditionData.ts)
    dataType = 0;

    // カラム幅
    columnWidth?: number | undefined;

    // カラム幅の最大幅
    columnMaxWidth?: number | undefined;

    constructor(_columnID: number = 0, _text: string = "", _dataType: number = 0, _columnWidth: number | undefined = undefined, _columnMaxWidth: number | undefined = undefined) {
        this.columnID = _columnID;
        this.text = _text;
        this.dataType = _dataType;
        this.columnWidth = _columnWidth;
        this.columnMaxWidth = _columnMaxWidth;
    }
}

/// <summary>
/// カラム幅データ
/// </summary>
export class ColumnWidthData {

    /// <summary>
    /// カラム幅
    /// </summary>
    columnWidth: number | undefined;

    /// <summary>
    /// 最小のカラム幅
    /// </summary>
    columnMinWidth: number | undefined;

    /// <summary>
    /// 最大のカラム幅
    /// </summary>
    columnMaxWidth: number | undefined;
}

// カラムタイプ
export enum SearchColumnType {
    string = 0x0001,		// 文字列
    number = 0x0002,		// 数値
    icon = 0x0004,          // アイコン
    link = 0x0008,          // リンク付き文字
    icon_s = 0x0010,          // アイコン(小さい)
    no_sort = 0x0020,       // ソートをしない
    html_column = 0x0040,       // HTML指定のカラム
    check_column = 0x0080,      // チェックタイプのカラム
}